// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Client portal notifications */

.notification-bell__button {
  color: #495057;
  position: relative;
}

.notification-bell__button:hover,
.notification-bell__button:focus {
  color: #212529;
}

.notification-bell__badge {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 1.1rem;
  padding: 0.15em 0.35em;
  font-size: 10px;
  line-height: 1.2;
  transform: translate(30%, -20%);
  box-shadow: 0 0 0 2px #f7f8fa;
}

.notification-bell__panel {
  display: block;
  width: 340px;
  max-height: 420px;
  overflow: auto;
  right: 0;
  left: auto;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
}

.notification-bell__header {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.notification-bell__item {
  border-bottom: 1px solid #e9ecef;
}

.notification-bell__item:last-child {
  border-bottom: none;
}

.notification-bell__link {
  color: #212529 !important;
  white-space: normal;
}

.notification-bell__link:hover,
.notification-bell__link:focus {
  background-color: #f1f3f5;
  color: #0d6efd !important;
}

.notification-bell__link--unread {
  background-color: rgba(13, 110, 253, 0.08);
  border-left: 3px solid #0d6efd;
}

.notification-bell__title {
  color: inherit;
  font-weight: 600;
}

.notification-bell__meta,
.notification-bell__body {
  color: #6c757d;
}

.notification-bell__dismiss {
  color: #6c757d !important;
}

.notification-center__item--unread {
  border-left: 3px solid #0d6efd;
  background-color: rgba(13, 110, 253, 0.06);
}

.notification-center__title {
  color: #212529;
}

.notification-center__title--read {
  color: #6c757d;
}

:root[data-theme="dark"] .notification-bell__button {
  color: #e9ecef !important;
}

:root[data-theme="dark"] .notification-bell__button:hover,
:root[data-theme="dark"] .notification-bell__button:focus {
  color: #ffffff !important;
}

:root[data-theme="dark"] .notification-bell__badge {
  box-shadow: 0 0 0 2px #1a1c1f;
  background-color: #ff4d5a !important;
  color: #fff !important;
}

:root[data-theme="dark"] .notification-bell__panel.dropdown-menu {
  background-color: #1a1d21;
  color: #f1f3f5;
  border-color: #3a4048;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.55);
}

:root[data-theme="dark"] .notification-bell__header {
  background: #242830;
  border-bottom-color: #3a4048;
  color: #f8f9fa;
}

:root[data-theme="dark"] .notification-bell__header .btn-link,
:root[data-theme="dark"] .notification-bell__header a.btn-link {
  color: #7eb6ff !important;
}

:root[data-theme="dark"] .notification-bell__item {
  border-bottom-color: #2f343c;
}

:root[data-theme="dark"] .notification-bell__link.dropdown-item {
  background-color: transparent;
  color: #f1f3f5 !important;
}

:root[data-theme="dark"] .notification-bell__link.dropdown-item:hover,
:root[data-theme="dark"] .notification-bell__link.dropdown-item:focus {
  background-color: #2a3038;
  color: #ffffff !important;
}

:root[data-theme="dark"] .notification-bell__link--unread {
  background-color: rgba(74, 158, 255, 0.18);
  border-left-color: #4a9eff;
}

:root[data-theme="dark"] .notification-bell__title {
  color: #ffffff;
}

:root[data-theme="dark"] .notification-bell__meta,
:root[data-theme="dark"] .notification-bell__body,
:root[data-theme="dark"] .notification-bell__empty,
:root[data-theme="dark"] .notification-bell__loading {
  color: #c5ccd6 !important;
}

:root[data-theme="dark"] .notification-bell__dismiss {
  color: #aeb6c2 !important;
}

:root[data-theme="dark"] .notification-center__item.list-group-item {
  background-color: #1a1d21;
  border-color: #2f343c;
  color: #f1f3f5;
}

:root[data-theme="dark"] .notification-center__item--unread {
  background-color: rgba(74, 158, 255, 0.14);
  border-left-color: #4a9eff;
}

:root[data-theme="dark"] .notification-center__title {
  color: #ffffff !important;
}

:root[data-theme="dark"] .notification-center__title--read {
  color: #c5ccd6 !important;
}

:root[data-theme="dark"] .notification-center__meta,
:root[data-theme="dark"] .notification-center__body {
  color: #c5ccd6 !important;
}

.notification-center .mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {
  content: '›';
}

.notification-center .mboss-breadcrumbs .breadcrumb-item.active {
  color: #6c757d;
}

:root[data-theme="dark"] .notification-center .mboss-breadcrumbs .breadcrumb-item a {
  color: #9ec9ff;
}

:root[data-theme="dark"] .notification-center .mboss-breadcrumbs .breadcrumb-item.active {
  color: #c5ccd6;
}

:root[data-theme="dark"] .notification-center .mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {
  color: #8b949e;
}

`, "",{"version":3,"sources":["webpack://./src/platform/notifications/notifications.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,QAAQ;EACR,UAAU;EACV,UAAU;EACV,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Client portal notifications */\n\n.notification-bell__button {\n  color: #495057;\n  position: relative;\n}\n\n.notification-bell__button:hover,\n.notification-bell__button:focus {\n  color: #212529;\n}\n\n.notification-bell__badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  min-width: 1.1rem;\n  padding: 0.15em 0.35em;\n  font-size: 10px;\n  line-height: 1.2;\n  transform: translate(30%, -20%);\n  box-shadow: 0 0 0 2px #f7f8fa;\n}\n\n.notification-bell__panel {\n  display: block;\n  width: 340px;\n  max-height: 420px;\n  overflow: auto;\n  right: 0;\n  left: auto;\n  padding: 0;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n}\n\n.notification-bell__header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.notification-bell__item {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.notification-bell__item:last-child {\n  border-bottom: none;\n}\n\n.notification-bell__link {\n  color: #212529 !important;\n  white-space: normal;\n}\n\n.notification-bell__link:hover,\n.notification-bell__link:focus {\n  background-color: #f1f3f5;\n  color: #0d6efd !important;\n}\n\n.notification-bell__link--unread {\n  background-color: rgba(13, 110, 253, 0.08);\n  border-left: 3px solid #0d6efd;\n}\n\n.notification-bell__title {\n  color: inherit;\n  font-weight: 600;\n}\n\n.notification-bell__meta,\n.notification-bell__body {\n  color: #6c757d;\n}\n\n.notification-bell__dismiss {\n  color: #6c757d !important;\n}\n\n.notification-center__item--unread {\n  border-left: 3px solid #0d6efd;\n  background-color: rgba(13, 110, 253, 0.06);\n}\n\n.notification-center__title {\n  color: #212529;\n}\n\n.notification-center__title--read {\n  color: #6c757d;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__button {\n  color: #e9ecef !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__button:hover,\n:root[data-theme=\"dark\"] .notification-bell__button:focus {\n  color: #ffffff !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__badge {\n  box-shadow: 0 0 0 2px #1a1c1f;\n  background-color: #ff4d5a !important;\n  color: #fff !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__panel.dropdown-menu {\n  background-color: #1a1d21;\n  color: #f1f3f5;\n  border-color: #3a4048;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.55);\n}\n\n:root[data-theme=\"dark\"] .notification-bell__header {\n  background: #242830;\n  border-bottom-color: #3a4048;\n  color: #f8f9fa;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__header .btn-link,\n:root[data-theme=\"dark\"] .notification-bell__header a.btn-link {\n  color: #7eb6ff !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__item {\n  border-bottom-color: #2f343c;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__link.dropdown-item {\n  background-color: transparent;\n  color: #f1f3f5 !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__link.dropdown-item:hover,\n:root[data-theme=\"dark\"] .notification-bell__link.dropdown-item:focus {\n  background-color: #2a3038;\n  color: #ffffff !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__link--unread {\n  background-color: rgba(74, 158, 255, 0.18);\n  border-left-color: #4a9eff;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__title {\n  color: #ffffff;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__meta,\n:root[data-theme=\"dark\"] .notification-bell__body,\n:root[data-theme=\"dark\"] .notification-bell__empty,\n:root[data-theme=\"dark\"] .notification-bell__loading {\n  color: #c5ccd6 !important;\n}\n\n:root[data-theme=\"dark\"] .notification-bell__dismiss {\n  color: #aeb6c2 !important;\n}\n\n:root[data-theme=\"dark\"] .notification-center__item.list-group-item {\n  background-color: #1a1d21;\n  border-color: #2f343c;\n  color: #f1f3f5;\n}\n\n:root[data-theme=\"dark\"] .notification-center__item--unread {\n  background-color: rgba(74, 158, 255, 0.14);\n  border-left-color: #4a9eff;\n}\n\n:root[data-theme=\"dark\"] .notification-center__title {\n  color: #ffffff !important;\n}\n\n:root[data-theme=\"dark\"] .notification-center__title--read {\n  color: #c5ccd6 !important;\n}\n\n:root[data-theme=\"dark\"] .notification-center__meta,\n:root[data-theme=\"dark\"] .notification-center__body {\n  color: #c5ccd6 !important;\n}\n\n.notification-center .mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {\n  content: '›';\n}\n\n.notification-center .mboss-breadcrumbs .breadcrumb-item.active {\n  color: #6c757d;\n}\n\n:root[data-theme=\"dark\"] .notification-center .mboss-breadcrumbs .breadcrumb-item a {\n  color: #9ec9ff;\n}\n\n:root[data-theme=\"dark\"] .notification-center .mboss-breadcrumbs .breadcrumb-item.active {\n  color: #c5ccd6;\n}\n\n:root[data-theme=\"dark\"] .notification-center .mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {\n  color: #8b949e;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
